import React from 'react';
import {connect} from 'react-redux';

// Components
import Anchor from 'Components/common/Anchor';
import Tag from 'Components/common/Tag';
import BasicButton from 'Components/common/BasicButton';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import ProductImage from 'Components/commonOrder/ProductImage';
import Dialog from 'Components/common/Dialog';
import {openNotification} from 'Actions/notification';

// Actions
import {
    getMyBackupList,
    updateBackupList,
    stockupRevoke,
} from 'Actions/userCenter';
import {T} from 'Actions/translate';

// Icons
import {ArrowBackIos} from '@material-ui/icons';
import {Grid} from '@material-ui/core';

class BackupList extends React.Component {
    pager = {
        pageNum: 0,
        pageSize: 10,
        pageTotal: 9999999999999,
    };
    state = {
        listLoaded: true,
        isBackupDialogOpened: false,
        currentId: 0,
    };

    componentWillMount() {
        this.props.updateBackupList({$set: []});
        this.getList();
    }

    getList = () => {
        if (this.state.listLoaded === false) return;

        this.setState({listLoaded: false});

        this.props
            .getMyBackupList({
                pageNum: this.pager.pageNum + 1,
                pageSize: this.pager.pageSize,
            })
            .then((res) => {
                this.pager.pageNum = res.pageNum;
                this.pager.pageSize = res.pageSize;
                this.pager.pageTotal = res.pageTotal || 1;
                this.setState({listLoaded: true});
            })
            .catch((res) => {
                this.setState({listLoaded: true});
            });
    };

    gotoBackup = () => {
        this.props.history.push('/requestBackup');
    };

    revokeBackup = (id) => {
        this.setState({
            isBackupDialogOpened: true,
            currentId: id,
        });
    };

    confirmRevokeBackup = () => {
        let {currentId} = this.state;
        let params = {
            ids: [currentId],
        };
        this.props
            .stockupRevoke(params)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.props.openNotification(T('backup_revoke_successs'));
                    this.pager.pageNum = 0;
                    this.getList();
                    this.setState({
                        currentId: 0,
                        isBackupDialogOpened: false,
                    });
                }
            })
            .catch((res) => {
                this.props.openNotification(T('backup_revoke_failure'));
            });
    };

    closeDialog = () => {
        this.setState({
            currentId: 0,
            isBackupDialogOpened: false,
        });
    };

    render() {
        let {isBackupDialogOpened} = this.state;
        return (
            <div className="backup-list-container">
                <div className="backup-list-header container-max-width is-fixed">
                    <Anchor
                        className="back-btn"
                        onClickOfSingleTap={() =>
                            this.props.history.push('/userCenter')
                        }>
                        <ArrowBackIos className="back-icon" />
                    </Anchor>
                    {T('backup_list_title')}
                </div>
                <ScrollWrapper
                    listLoaded={this.state.listLoaded}
                    showAbyss={this.pager.pageNum >= this.pager.pageTotal}
                    showLoadingMore={!this.state.listLoaded}
                    getMoreData={this.getList}>
                    <ul className="backup-list">
                        {this.props.backupList.map((item, index) => (
                            <li className="backup-item" key={index}>
                                <h4 className="sku">{item.sku}</h4>
                                <section className="backup-info">
                                    <div className="image-box">
                                        <ProductImage
                                            id={item.id}
                                            src={item.pic}
                                            alt={item.sku}
                                            key={item.pic}
                                        />
                                    </div>
                                    <div>
                                        <p className="row text-ellipsis">
                                            <label>
                                                {T('backup_quantity')}:
                                            </label>{' '}
                                            {item.applyQuantity}
                                        </p>
                                        <p className="row text-ellipsis">
                                            <label>
                                                {T('backup_supply_center')}:
                                            </label>{' '}
                                            {item.scName}
                                        </p>
                                        {/* <p className="row text-ellipsis">
                                            <label>
                                                {T('backup_lab_or_dept')}:
                                            </label>{' '}
                                            {item.stAlphaName}
                                        </p>
                                        <p className="row text-ellipsis">
                                            <label>
                                                {T('backup_delivery_date')}:
                                            </label>{' '}
                                            {item.crd}
                                        </p> */}
                                        {this.props.localData.roleType !== 0 ? (
                                            <p className="row text-ellipsis">
                                                <label>
                                                    {T(
                                                        'backup_application_date',
                                                    )}
                                                    :
                                                </label>{' '}
                                                {item.createTime}
                                            </p>
                                        ) : null}
                                        {/* {item.remark ? (
                                            <p className="row text-ellipsis">
                                                <label>
                                                    {T('backup_comments')}:
                                                </label>{' '}
                                                {item.remark}
                                            </p>
                                        ) : null} */}
                                    </div>
                                </section>
                                {this.props.localData.roleType !== 0 &&
                                item.status === 'INIT' ? (
                                    <div className="backup-revoke">
                                        <BasicButton
                                            className="revoke-btn"
                                            type="primary"
                                            onClickOfSingleTap={() =>
                                                this.revokeBackup(item.id)
                                            }>
                                            {T('backup_revoke')}
                                        </BasicButton>
                                    </div>
                                ) : null}
                                {this.props.localData.roleType === 3 ||
                                this.props.localData.roleType === 2 ? (
                                    item.status === 'INIT' ? (
                                        <Tag
                                            className="tag backup-list-tag-i"
                                            value={T(
                                                `backup_status_${item.status}`,
                                            )}
                                            size="6rem"
                                        />
                                    ) : item.status === 'APPROVED' ? (
                                        <Tag
                                            className="tag backup-list-tag-a"
                                            value={T(
                                                `backup_status_${item.status}`,
                                            )}
                                            size="6rem"
                                        />
                                    ) : item.status === 'REVOKE' ? (
                                        <Tag
                                            className="tag backup-list-tag-a"
                                            value={T(
                                                `backup_status_${item.status}`,
                                            )}
                                            size="6rem"
                                        />
                                    ) : item.status === 'DECLINE' ? (
                                        <Tag
                                            className="tag backup-list-tag-d"
                                            value={T(
                                                `backup_status_${item.status}`,
                                            )}
                                            size="6rem"
                                        />
                                    ) : item.status === 'RECALL' ? (
                                        <Tag
                                            className="tag backup-list-tag-r"
                                            value={T(
                                                `backup_status_${item.status}`,
                                            )}
                                            size="6rem"
                                        />
                                    ) : null
                                ) : null}
                            </li>
                        ))}
                    </ul>
                </ScrollWrapper>
                <div className="backup-list-footer-wrap">
                    <div className="backup-list-footer container-max-width is-fixed">
                        <BasicButton
                            className="backup-btn"
                            type="primary"
                            onClickOfSingleTap={this.gotoBackup}>
                            {T('backup_apply')}
                        </BasicButton>
                    </div>
                </div>

                <Dialog
                    options={{bgClickClose: true}}
                    opened={isBackupDialogOpened}
                    dialogDidClose={this.closeDialog}>
                    <div className="confirm-popup">
                        <Grid
                            className="confirm-title-container"
                            container
                            spacing={0}>
                            <Grid className="confirm-title-grid" item xs={12}>
                                <span>{T('backup_revoke_backup')}</span>
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid
                                    className="confirm-revoke-label"
                                    item
                                    xs={12}>
                                    <span>
                                        {T('backup_confirm_revoke_backup')}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid
                            className="conversion-button-container"
                            container
                            spacing={0}>
                            <Grid className="default-button-grid" item xs={12}>
                                <BasicButton
                                    disabled={false}
                                    className="confirm-conversion-btn"
                                    onClickOfSingleTap={
                                        this.confirmRevokeBackup
                                    }>
                                    <span>{T('backup_revoke')}</span>
                                </BasicButton>
                                <BasicButton
                                    disabled={false}
                                    className="cancel-conversion-btn"
                                    onClickOfSingleTap={this.closeDialog}>
                                    <span>{T('cancel')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {userCenter, localData} = state;

    return {
        backupList: userCenter.backupList,
        localData,
    };
};

const mapDispatchToProps = {
    getMyBackupList,
    updateBackupList,
    stockupRevoke,
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackupList);
